import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ChoooseNavCategory } from "../../Products/HandleProductFilter";
import { ProductCategory } from "../../Products/ProduArrs";

const BottomNav = () => {
  const dispatch = useDispatch();
  const { navCategory } = useSelector((state) => state.filterProds);

  function ChoooseNavCategoryClick(e) {
    ChoooseNavCategory(e, dispatch);
  }

  console.log(navCategory);
  return (
    <div className="hidden md:block">
      <nav className="flex items-center justify-center bg-white text-black h-12 max-w-[1320px] mx-auto">
        <ul className="flex items-center justify-around w-full md:w-auto flex-1">
          {ProductCategory.map((cat) => (
            <li
              key={cat}
              onClick={ChoooseNavCategoryClick}
              className="px-2 hover:text-gray-400 font-workSans font-normal cursor-pointer"
            >
              {cat}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default BottomNav;
